import React from 'react';
import { connect } from 'react-redux';
import HardwareComponent from '@/containers/CampaignDetail/Hardware/Hardware';
import Notes from '@/containers/SubCampaignDetail/Notes/Notes';
import { TABS } from '@/helpers/constants';
import { getIsVANCR } from '@/redux/Campaign/campaign.reducer';
import { setSubCampaignHardwareNotes, setSubCampaignOriginalValues } from '@/redux/SubCampaign/subCampaign.action';
import { getSubcampaignHardwareNotes, getSubCampaignOriginalValues } from '@/redux/SubCampaign/subCampaign.reducer';
import { OriginalValues } from '@/types';

interface HardwareProps {
  setHardwareNotes: (notes: string[]) => void;
  hardwareNotes: string[];
  setOriginalValues: (values: OriginalValues) => void;
  originalValues: OriginalValues;
  isVANCR: boolean;
}

const Hardware = (props: HardwareProps) => {
  const { setHardwareNotes, hardwareNotes, setOriginalValues, originalValues, isVANCR } = props;

  const addNotes = () => {
    setHardwareNotes([...hardwareNotes, '']);
  };

  const onSetOriginValues = () => {
    const values = {
      ...originalValues,
      hasChange: true,
    };
    setOriginalValues(values);
  };

  const handleChangeText = (comment: string, id: number) => {
    const newState = [...hardwareNotes];
    newState.splice(id, 1, comment);
    setHardwareNotes(newState);
    onSetOriginValues();
  };

  return (
    <>
      <HardwareComponent subCR />
      {!isVANCR && (<Notes notes={hardwareNotes} addNotes={addNotes} handleChangeText={handleChangeText} tab={TABS.affectedHardware.label} />)}
    </>
  );
};

const mapStateToProps = (state) => ({
  hardwareNotes: getSubcampaignHardwareNotes(state),
  originalValues: getSubCampaignOriginalValues(state),
  isVANCR: getIsVANCR(state),
});

const actionCreators = {
  setHardwareNotes: setSubCampaignHardwareNotes,
  setOriginalValues: setSubCampaignOriginalValues,
};

export default connect(mapStateToProps, actionCreators)(Hardware);
